import { z } from 'zod';

const optionalText = (max, label) => z
  .string()
  .max(max, `${label}最多 ${max} 字`)
  .optional()
  .or(z.literal(''));

const addressRowSchema = z.object({
  addressType: optionalText(50, '地址類型'),
  postalCode: optionalText(20, '郵遞區號'),
  city: optionalText(50, '縣市'),
  district: optionalText(50, '行政區'),
  address: z.string().trim().min(1, '地址不能為空').max(500, '地址最多 500 字'),
  isDefault: z.boolean().optional(),
  remark: optionalText(500, '備註'),
});

const contactRowSchema = z.object({
  name: z.string().trim().min(1, '聯絡人姓名不能為空').max(100, '姓名最多 100 字'),
  department: optionalText(100, '部門'),
  title: optionalText(100, '職稱'),
  phone: optionalText(50, '電話'),
  mobile: optionalText(50, '手機'),
  email: optionalText(200, 'Email'),
  isDefault: z.boolean().optional(),
  remark: optionalText(500, '備註'),
});

export const processingFactoryFormSchema = z.object({
  code: z.string().trim().min(1, '代號不能為空').max(50, '代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  chineseName: optionalText(100, '中文名'),
  englishName: optionalText(100, '英文名'),
  taxIdNumber: optionalText(50, '統編'),
  homepage: optionalText(200, '網址'),
  phone: optionalText(50, '電話'),
  fax: optionalText(50, '傳真'),
  warehouseIds: z.array(z.string()).min(1, '請至少選擇一個工作倉'),
  remark: optionalText(500, '備註'),
  addresses: z.array(addressRowSchema),
  contacts: z.array(contactRowSchema),
});

export const PROCESSING_FACTORY_FORM_DEFAULT_VALUES = {
  code: '',
  name: '',
  chineseName: '',
  englishName: '',
  taxIdNumber: '',
  homepage: '',
  phone: '',
  fax: '',
  warehouseIds: [],
  remark: '',
  addresses: [],
  contacts: [],
};
